<template>
    <div class="l-ss-c-filter-label">
        <span>{{ label }}</span>
        <i
            v-if="showArrow"
            v-html="iconArrowTop"></i>
    </div>
</template>

<script>
    import iconArrowTop from '@/core/assets/images/icons/arrow-top.svg';

    export default {
        props: {
            label: String,
            showArrow: {
                type: Boolean,
                default: true,
            },
        },
        setup() {
            return {
                iconArrowTop,
            };
        },
    };
</script>
